import React, { useEffect } from "react";
import CyberLaw from "./cyber-law";
import { useChat } from "../../../../context/contextChat";

const CyberLawBody = () => {
  const { showCyberLaw, setShowCyberLaw } = useChat();
  useEffect(() => {
    if (showCyberLaw) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "unset";
    }
    return () => {
      document.body.style.overflow = "unset";
    };
  }, [showCyberLaw]);
  if (!showCyberLaw) return null;

  return (
    <div 
      className="position-fixed top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center"
      style={{
        zIndex: 1060,
        backgroundColor: "rgba(15, 23, 42, 0.45)", 
        backdropFilter: "blur(12px)",
        animation: "cyberLawFadeIn 0.2s ease-out"
      }}
    >
      <div 
        className="card d-flex flex-column border-0 bg-white w-100 mx-3 mx-md-0 shadow-2xl"
        style={{
          maxWidth: "1000px",
          height: "85vh",
          maxHeight: "780px",
          borderRadius: "24px",
          overflow: "hidden",
          boxShadow: "0 25px 50px -12px rgba(0, 0, 0, 0.25)"
        }}
      >
        <div 
          className="px-4 py-3.5 d-flex align-items-center justify-content-between border-bottom"
          style={{ backgroundColor: "#f8fafc" }}
        >
          <div className="d-flex align-items-center gap-3 py-3">            
            <div>
              <h5 className="fw-bold mb-0 text-slate-900" style={{ letterSpacing: "-0.5px" }}>
                Legal & Regulatory Frameworks
              </h5>
              <p className="text-muted mb-0 small" style={{ fontSize: "0.72rem" }}>
                Global cybersecurity compliance directives, jurisdiction matrix codes, and statutes
              </p>
            </div>
          </div>
          <button 
            type="button" 
            className="btn btn-light rounded-circle p-0 d-flex align-items-center justify-content-center border shadow-sm"
            style={{ width: "34px", height: "34px" }}
            onClick={() => setShowCyberLaw(false)}
          >
            <i className="bi bi-x lg text-secondary" style={{ fontSize: "1.2rem" }} />
          </button>
        </div>
        <div className="flex-grow-1 overflow-hidden p-0">
          <CyberLaw />
        </div>
      </div>
      <style>{`
        @keyframes cyberLawFadeIn {
          from { opacity: 0; transform: scale(0.98); }
          to { opacity: 1; transform: scale(1); }
        }
      `}</style>
    </div>
  );
};

export default CyberLawBody;